import { render, staticRenderFns } from "./AccountsInventory.vue?vue&type=template&id=61bce64a&scoped=true"
import script from "./AccountsInventory.vue?vue&type=script&lang=js"
export * from "./AccountsInventory.vue?vue&type=script&lang=js"
import style0 from "./AccountsInventory.vue?vue&type=style&index=0&id=61bce64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bce64a",
  null
  
)

export default component.exports